<span class="text-neutral-900 fw-semibold cursor-pointer hover-underline"
    [ngbTooltip]="value.join(', ')"    
>
    See all sources ({{value?.length || 0}})
</span> 